import React from 'react';

import ScheduleApi from '../../api-services/ScheduleApi';

import ScheduleMain from '../../schedules/ScheduleMain';

import UniformDailyColumnManager from './UniformDailyColumnManager';
import UniformDailyDataModel from './UniformDailyDataModel';
import UniformDailySummaryView from './UniformDailySummaryView';

export class UniformDailyMain extends ScheduleMain {
  constructor(props) {
    super(props);

    this.dataModel = new UniformDailyDataModel(
      this.locale,
      this.counterparty,
      this.commandDataModel,
      this.summaryDataModel
    );

    this.columnManager = new UniformDailyColumnManager(
      this.session,
      this.counterparty
    );
    this.columnManager.settings.loadColumnSettings();
  }

  getDataGridRowClassName() {
    return 'pwx-opt-in-datagrid-row';
  }

  renderUsageSummaries() {
    return (
      <div>
        <UniformDailySummaryView
          dataModel={this.summaryDataModel}
          locale={this.locale}
        />
      </div>
    );
  }

  async loadGridValues() {
    var scheduleUpdateDto = await ScheduleApi.getFullUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth
    );

    this.dataModel.processFullServerUpdate(scheduleUpdateDto);

    this.commandDataModel.updateProperties({
      isEditingEnabled: this.dataModel.isEditingEnabled,
      canUserManageColumnPreferences: scheduleUpdateDto.canUserManageColumnPreferences,
      currentContracts: this.dataModel.contracts,
      resubmitContracts: this.dataModel.contracts.filter(contract => contract.enableResubmitValues),
      recalculateContracts: this.dataModel.contracts.filter(contract => contract.enableRecalculateValues)
    });
  }

  async updateGridValues(lastRetrievalTimeUtc) {
    var scheduleUpdateDto = await ScheduleApi.getPartialUpdate(
      this.counterparty.code,
      this.commandDataModel.currentMonth,
      lastRetrievalTimeUtc
    );

    this.dataModel.processBackgroundServerUpdate(scheduleUpdateDto);
  }

  submitGridChanges(onSubmitFinished) {
    var dateSubmissions = this.dataModel.getCurrentModifications();
    ScheduleApi.submitChanges(
      this.counterparty.code,
      dateSubmissions,
      onSubmitFinished,
      false
    );
  }

  revertGridChanges() {
    this.dataModel.revertCurrentModifications();
  }
}
